import 'lazysizes';

import { ImageAutoOptimizer } from './image-auto-optimizer';

/* lazysizes API events */
document.addEventListener('lazybeforeunveil', function(e) {
    const $target = $(e.target);
    ImageAutoOptimizer.buildUrl($target);

    const bg = $target.attr('data-bg');
    if (bg) {
        $target.css('background-image', 'url(' + bg + ')');
    }
});
document.addEventListener('lazyloaded', function(e) {
    const $target = $(e.target);

    if ($target.hasClass('js-link-wrapper-target')) {
        const $ciLinkWrapper = $target.closest('.' + $target.data('parent-class')).find('.js-link-wrapper-lazyload');
        if ($ciLinkWrapper.length) {
            import(ICUBE_LINK_WRAPPER).then(() => $ciLinkWrapper.ciLinkWrapper())
        }
    }
});
/* END lazysizes API events */

export const Lazyloader = {
    /* globalna inicjacja lazyloada obrazów */
    init: () => {
        lazySizes.init();
    }, 
    /* lazyload pojedynczego obrazu */
    load: ($image) => {
        lazySizes.loader.unveil($image.get(0)); 
    } 
}